import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import NavItem from "../NavItem/NavItem";
import PropTypes from "prop-types";
import styles from "./GetStartedHeader.module.css";
import classNames from "classnames";

export const GetStartedHeader = ({ header, img, options }) => {
  const navigate = useNavigate();
  const [isGetStartedDropdownOpen, setIsGetStartedDropdownOpen] =
    useState(false);

  return (
    <div className={`${styles.container}`}>
      <div className={styles.mainBodyContainer}>
        <div className={styles.subContainer}>
          <div
            className={`col-lg-6 col-md-12 ${styles.customContainer} `}
            style={{}}
          >
            <h5 className={`${styles.h5} ${styles.fadeInDownElement}`}>
              {header}
            </h5>
            <div className={styles.fadeInDownElement2}>
              <div className={styles.customNavItemStyle}>
                <NavItem
                  label="GET STARTED"
                  options={options}
                  border={true}
                  onClick={(path) => {
                    navigate(path);
                  }}
                />
              </div>
            </div>
          </div>

          <div className={styles.device}>
            <img
              className={classNames(styles.imgStyle, styles.none)}
              src={img}
              alt="Product"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

GetStartedHeader.propTypes = {
  header: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    })
  ).isRequired,
};
